import Modal from "./Modal.component";

const CongratulationsModal = ({ setPopupOpen, setReservationState, setModalGBPickerModalOpen }: any) => {
  return (
    <Modal
      setPopupOpen={()=>{setPopupOpen(false);setModalGBPickerModalOpen(false);}}
      title="Reserve Successful!"
      style={{ width: "743px" }}
      setReservationState={setReservationState}
    >
      <p style={{ textAlign: "center" }}>
        Congratulations! Your NFT has been successfully reserved for
        illustration. You will receive your NFT within a few weeks.
      </p>
    </Modal>
  );
};

export default CongratulationsModal;
